import React, { useEffect, useState, useRef } from "react";

import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  NavItem,
  NavLink,
  Row,
  TabContent,
  Tooltip,
  TabPane,
  CardTitle,
  Collapse,
} from "reactstrap";
import InputMask from "react-input-mask";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
import classnames from "classnames";
import { Link, useNavigate } from "react-router-dom";
import Spinners from "components/Common/Spinner";
import Select from "react-select";
import Config from "config";
import FloatingFormActions from "components/Common/FloatingFormActions";
import {
  FiUser,
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiCalendar,
} from "react-icons/fi";
import { BsFillInfoCircleFill } from "react-icons/bs";
const FormWizard = () => {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  //meta title
  document.title = "DOM COM | Nouvel investisseur";
  const token = localStorage.getItem("auth_token_" + api);
  const navigate = useNavigate();
  
  // États pour les boutons flottants
  const [showFloatingButtons, setShowFloatingButtons] = useState(false);
  const [isFormVisible, setIsFormVisible] = useState(true);
  const formEndRef = useRef(null);
  let currentLeftSideBar = localStorage.getItem("leftSideBar");
  const [leftPosition, setLeftPosition] = useState(
    localStorage.getItem("leftSideBar") === "icon" ? true : false
  );
  
  // Vérifier périodiquement le changement de la sidebar
  setInterval(() => {
    const newValue = localStorage.getItem("leftSideBar");
    if (newValue !== currentLeftSideBar) {
      currentLeftSideBar = newValue;
      const isIcon = newValue === "icon";
      setLeftPosition(isIcon);
    }
  }, 100);
  
  // Observer pour détecter si les boutons sont visibles
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        setShowFloatingButtons(!entry.isIntersecting);
      },
      {
        threshold: 0.1,
        rootMargin: "0px 0px -100px 0px",
      }
    );

    if (formEndRef.current) {
      observer.observe(formEndRef.current);
    }

    return () => observer.disconnect();
  }, []);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [loading, setLoading] = useState(true);
  const [isCoordonneesAccordionOpen, setIsCoordonneesAccordionOpen] =
    useState(true);
  const toggleCoordonneesAccordion = () =>
    setIsCoordonneesAccordionOpen((o) => !o);
  const [isAdresseAccordionOpen, setIsAdresseAccordionOpen] = useState(true);
  const toggleAdresseAccordion = () => setIsAdresseAccordionOpen((o) => !o);
  const [isCoordContactAccordionOpen, setIsCoordContactAccordionOpen] =
    useState(true);
  const toggleCoordContactAccordion = () =>
    setIsCoordContactAccordionOpen((o) => !o);
  const [
    isRenseignementsPersoAccordionOpen,
    setIsRenseignementsPersoAccordionOpen,
  ] = useState(true);
  const toggleRenseignementsPersoAccordion = () =>
    setIsRenseignementsPersoAccordionOpen((o) => !o);
  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
      marginTop: "-8px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "#fff", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  // Nom, prénom, date de naissance, ville de naissance, département de naissance, profession
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [dateNaissance, setDateNaissance] = useState("");
  const [villeNaissance, setVilleNaissance] = useState("");
  const [depNaissance, setDepNaissance] = useState("");
  const [profession, setProfession] = useState("");
  const [adresseFiscale, setAdresseFiscale] = useState("");
  const [complementAdresse, setComplementAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [emailPersonnel, setEmailPersonnel] = useState("");
  const [emailProfessionel, setEmailProfessionel] = useState("");
  const [telephoneFixe, setTelephoneFixe] = useState("");
  const [telephoneMobile, setTelephoneMobile] = useState("");
  const smartCapitalizeWithDash = (word, originalWord) => {
    return word
      .split("-")
      .map((subWord, subIndex) => {
        const originalSubWord = originalWord.split("-")[subIndex] || "";

        // Préserve les majuscules existantes
        return subWord
          .split("")
          .map((char, charIndex) => {
            const originalChar = originalSubWord[charIndex];
            if (originalChar && originalChar === originalChar.toUpperCase()) {
              return char.toUpperCase();
            }
            return charIndex === 0 ? char.toUpperCase() : char.toLowerCase();
          })
          .join("");
      })
      .join("-");
  };

  const handleParenthesis = (word, originalWord) => {
    // Gérer les parenthèses comme "Casablanca (Maroc)"
    if (word.includes("(") && word.includes(")")) {
      const mainPart = word.substring(0, word.indexOf("(")).trim();
      const parenthesisPart = word.substring(
        word.indexOf("(") + 1,
        word.indexOf(")")
      );
      const afterParenthesis = word.substring(word.indexOf(")") + 1);

      // Parties originales pour préserver majuscules
      const originalMainPart = originalWord
        .substring(0, originalWord.indexOf("("))
        .trim();
      const originalParenthesisPart = originalWord.substring(
        originalWord.indexOf("(") + 1,
        originalWord.indexOf(")")
      );

      const capitalizedMain = smartCapitalizeWithDash(
        mainPart,
        originalMainPart
      );
      const capitalizedParenthesis = smartCapitalizeWithDash(
        parenthesisPart,
        originalParenthesisPart
      );

      return `${capitalizedMain} (${capitalizedParenthesis})${afterParenthesis}`;
    }
    return smartCapitalizeWithDash(word, originalWord);
  };
  const handleVilleNaissanceChange = (e) => {
    const rawValue = e.target.value;

    // Utilise une regex pour capitaliser chaque mot
    const transformedValue = rawValue.toLowerCase().replace(/\b\w/g, (char) => {
      return char.toUpperCase();
    });

    console.log(transformedValue);
    setVilleNaissance(transformedValue);
  };

  /*************************   TITRE *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [titre, setTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: (titreData?.data || []).map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getTitre();
        await getSituationMatrimoniale();
        await getPay();
        await getPartenaire();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
    setTimeout(() => {
      setLoading(false);
    }, 500);
  }, []);
  /*************************   Pays  *******************************/
  const [pay, setPay] = useState("");
  const [payData, setPayData] = useState({ data: [] });
  const renderPayOptions = () => {
    return [
      {
        options: (payData?.data || []).map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePayChange = (e) => {
    setPay(e);
  };
  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/

  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [situationMatrimoniale, setSituationMatrimoniale] = useState("");

  const renderSituationMatrimonialeOptions = () => {
    return [
      {
        options: (situationMatrimonialeData?.data || []).map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  /*************************   Partenaire  *******************************/
  const [partenaireData, setPartenaireData] = useState({
    data: [],
  });

  const [partenaire, setPartenaire] = useState("");

  const renderPartenaireOptions = () => {
    return [
      {
        options: (partenaireData?.data || []).map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handlePartenaireChange = (e) => {
    setPartenaire(e);
  };
  const getPartenaire = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/partenaires`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((partenaireCollection) => {
          setPartenaireData(partenaireCollection);
          // si partenaireData contient qu'un seul element, on set le partenaire
          console.log(partenaireCollection);
          console.log(partenaireCollection?.data?.length);
          if (partenaireCollection?.data?.length === 1) {
            setPartenaire(partenaireCollection.data[0]);
          }
          console.log(partenaire);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END SituationMatrimoniale *******************************/
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/investisseurs/send_new_invest`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            nom: nom,
            prenom: prenom,
            titre_id: titre?.value || "",
            date_de_naissance: dateNaissance,
            ville_de_naissance: villeNaissance,
            departement_ou_pays: depNaissance,
            profession: profession,
            situation_matrimoniale_id: situationMatrimoniale?.value || "",
            partenaire_id: partenaire?.value || partenaire?.id || "",
            pay_id: pay?.value || "",
            adresse_fiscale: adresseFiscale,
            complement_adresse: complementAdresse,
            code_postal: codePostal,
            ville: ville,
            email_perso: emailPersonnel,
            // email_professionel: emailProfessionel,
            // tel_fixe: telephoneFixe,
            tel_mob: telephoneMobile,
          }),
        }
      );
      if (response.ok) {
        console.log("POST request successful");
        const responseData = await response.json();
        toast.success(responseData?.message);
        navigate(`${backUrl}/investisseurs/${responseData?.investisseur_id}`);
        setLoading(false);
      } else {
        console.error("POST request failed");
        const responseData = await response.json();
        if (responseData && responseData.error) {
          toast.error(responseData.error);
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row className="mb-2">
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-4 card-title flex-grow-1"
                      style={{ fontWeight: "bold" }}
                    >
                      <Link
                        to={`${backUrl}/investisseurs/`}
                        style={{
                          color: "#555B21",
                          textDecoration: "underline !important",
                        }}
                      >
                        Investisseurs
                      </Link>{" "}
                      <i className="bx bx-caret-right"></i> Nouvel investisseur
                    </h5>
                  </div>
                  {loading ? (
                    <Spinners setLoading={setLoading} setWait={400} />
                  ) : (
                    <>
                      <div className="wizard clearfix">
                        <div className=" clearfix">
                          <Card>
                            <TabPane tabId={1}>
                              <Form>
                                <>
                                  <Row className="mb-2">
                                    <Col sm="6">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En-tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={toggleCoordonneesAccordion}
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Coordonnées personnelles
                                            </span>
                                          </div>
                                          {isCoordonneesAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        {/* Contenu repliable */}
                                        <Collapse
                                          isOpen={isCoordonneesAccordionOpen}
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {/* Partenaire */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Partenaire
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="select-wrapper">
                                                      <Select
                                                        defaultValue={
                                                          partenaire
                                                        }
                                                        onChange={
                                                          handlePartenaireChange
                                                        }
                                                        options={renderPartenaireOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        isSearchable={false}
                                                        placeholder="Sélectionner un partenaire..."
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Titre */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Titre
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={titre}
                                                        onChange={
                                                          handleTitreChange
                                                        }
                                                        options={renderTitreOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        isSearchable={false}
                                                        placeholder="Sélectionner un titre..."
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Nom */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Nom
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className={`form-control form-control-sm shadow-sm border-0 ${""}`}
                                                        style={{
                                                          textTransform:
                                                            "uppercase",
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        value={nom}
                                                        required
                                                        onChange={(e) =>
                                                          setNom(
                                                            e.target.value.toUpperCase()
                                                          )
                                                        }
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Prénom */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Prénom
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        style={{
                                                          textTransform:
                                                            "capitalize",
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        value={prenom}
                                                        onChange={(e) =>
                                                          setPrenom(
                                                            e.target.value
                                                              .charAt(0)
                                                              .toUpperCase() +
                                                              e.target.value
                                                                .slice(1)
                                                                .toLowerCase()
                                                          )
                                                        }
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Date de naissance */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Date de naissance
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <InputMask
                                                        mask="99/99/9999"
                                                        value={dateNaissance}
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        onChange={(
                                                          dateString
                                                        ) =>
                                                          setDateNaissance(
                                                            dateString.target
                                                              .value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiCalendar
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Ville de naissance */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Ville de naissance
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={villeNaissance}
                                                        required
                                                        onChange={
                                                          handleVilleNaissanceChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Code département de naissance */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Code département de
                                                        naissance
                                                      </span>
                                                      <BsFillInfoCircleFill
                                                        size={14}
                                                        className="text-info ms-1"
                                                        style={{
                                                          cursor: "pointer",
                                                        }}
                                                        id="CodeDepartementNaissance"
                                                      />
                                                      <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen}
                                                        target="CodeDepartementNaissance"
                                                        toggle={toggleTooltip}
                                                      >
                                                        Saisir le numéro du
                                                        département pour la
                                                        France et le pays en
                                                        toutes lettres lorsque
                                                        l’investisseur est né
                                                        hors de France.
                                                      </Tooltip>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={depNaissance}
                                                        required
                                                        onChange={(e) =>
                                                          setDepNaissance(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>

                                    <Col sm="6">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En‑tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={toggleAdresseAccordion}
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Adresse
                                            </span>
                                          </div>
                                          {isAdresseAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        {/* Contenu repliable */}
                                        <Collapse
                                          isOpen={isAdresseAccordionOpen}
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {/* Adresse résidence fiscale */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Adresse résidence
                                                        fiscale
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        required
                                                        value={adresseFiscale}
                                                        onChange={(e) =>
                                                          setAdresseFiscale(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Complément adresse */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Complément adresse
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={
                                                          complementAdresse
                                                        }
                                                        onChange={(e) =>
                                                          setComplementAdresse(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Code postal */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Code postal
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        required
                                                        value={codePostal}
                                                        onChange={(e) =>
                                                          setCodePostal(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Ville */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Ville
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={ville}
                                                        required
                                                        onChange={(e) =>
                                                          setVille(
                                                            e.target.value.toUpperCase()
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Pays */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Pays
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="select-wrapper">
                                                      <Select
                                                        onChange={
                                                          handlePayChange
                                                        }
                                                        options={renderPayOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner un pays..."
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>
                                  </Row>
                                  <Row className="mb-2">
                                    <Col sm="6">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En‑tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={toggleCoordContactAccordion}
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Coordonnées de contact
                                            </span>
                                          </div>
                                          {isCoordContactAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        {/* Contenu repliable */}
                                        <Collapse
                                          isOpen={isCoordContactAccordionOpen}
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {/* E-mail personnel */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        E-mail personnel
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        type="email"
                                                        required
                                                        value={emailPersonnel}
                                                        onChange={(e) =>
                                                          setEmailPersonnel(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(220, 53, 69, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Téléphone mobile */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Téléphone mobile
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        required
                                                        value={telephoneMobile}
                                                        onChange={(e) =>
                                                          setTelephoneMobile(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>

                                    <Col sm="6">
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En‑tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={
                                            toggleRenseignementsPersoAccordion
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Renseignements Divers
                                            </span>
                                          </div>
                                          {isRenseignementsPersoAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        {/* Contenu repliable */}
                                        <Collapse
                                          isOpen={
                                            isRenseignementsPersoAccordionOpen
                                          }
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {/* Profession */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Profession
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="input-wrapper position-relative">
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={profession}
                                                        required
                                                        onChange={(e) =>
                                                          setProfession(
                                                            e.target.value
                                                          )
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 2rem 0.375rem 0.5rem",
                                                          height: "32px",
                                                          transition:
                                                            "all 0.2s ease",
                                                        }}
                                                        onFocus={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffffff";
                                                          e.currentTarget.style.boxShadow =
                                                            "0 0 0 0.2rem rgba(0, 123, 255, 0.15)";
                                                        }}
                                                        onBlur={(e) => {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#f8f9fa";
                                                          e.currentTarget.style.boxShadow =
                                                            "none";
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>

                                              {/* Situation matrimoniale */}
                                              <div
                                                className="field-item px-2 py-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid transparent",
                                                  position: "relative",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Situation matrimoniale
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <div className="select-wrapper">
                                                      <Select
                                                        value={
                                                          situationMatrimoniale
                                                        }
                                                        onChange={
                                                          handleSituationMatrimonialeChange
                                                        }
                                                        options={renderSituationMatrimonialeOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        isSearchable={false}
                                                        styles={styles(false)}
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        placeholder="Sélectionner une situation..."
                                                      />
                                                    </div>
                                                  </Col>
                                                </Row>
                                              </div>
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Col>
                                  </Row>
                                  <div ref={formEndRef} style={{ height: "1px" }} />
                                </>
                              </Form>
                            </TabPane>
                          </Card>
                        </div>
                      </div>
                      <FloatingFormActions
                        showFloatingButtons={showFloatingButtons}
                        leftPosition={leftPosition}
                        onCancel={() => navigate(-1)}
                        onSubmit={handleSubmit}
                        isSubmitting={false}
                        disabled={false}
                        submitText="Créer"
                      />
                    </>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
};

export default FormWizard;
